export default __webpack_public_path__ + "static/media/confirmation-illustra.11443dce.svg";